import React, { useState, useEffect } from "react";
import "./OrderDetails.css";

import { connect } from "react-redux";
import { useParams } from "react-router-dom";
import * as actions from "../../store/actions";
import Spinner from "../../containers/UI/Spinner/Spinner";

import ClearIcon from "@mui/icons-material/Clear";

import axios from "../../services/apiClient";

const prod = "http://dbutler.qa/pdfgenerate/";
const dev = "http://dev.dbutler.qa/pdfgenerate/";
let serverAddress = process.env.REACT_APP_ENV === "development" ? dev : prod;

const OrderDetails = (props) => {
  const { orderID } = useParams();
  
  const [isReportModalOpen, setIsReportModalOpen] = useState(false);
  const [reportModalTitle, setReportModalTitle] = useState("");
  const [reportModalText, setReportModalText] = useState("");
  const [rejectOrderModalOpen, setRejectOrderModalOpen] = useState(false);
  const [checkboxList, setCheckboxList] = useState([
    { name: "Out of stock", checked: false },
    { name: "Near expiry", checked: false },
    { name: "Already reserved", checked: false },
    { name: "Other", checked: false },
  ]);
  const [rejectDescription, setRejectDescription] = useState("");
  const [rejectionLoading, setRejectionLoading] = useState(false);
  const [isRejectProductModalOpen, setIsRejectProductModalOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);

  const callGetAPI = () => {
    props.getOneOrders(orderID);
  };

  useEffect(() => {
    callGetAPI();
  }, [orderID]);

  const handleClickOrder = (orderId, action) => {
    // Handle reject/cancel action through modal
    if (action === 'cancel') {
      setRejectOrderModalOpen(true);
    } else {
      // Use workflow-based actions: 'confirm', 'prepare', 'ready', 'delivered'
      props.confirmOrder(orderId, action, callGetAPI);
    }
  };

  const handleReportInputs = (e) => {
    const { name, value } = e.target;
    if (name === "reportModalTitle") {
      setReportModalTitle(value);
    } else if (name === "reportModalText") {
      setReportModalText(value);
    } else if (name === "rejectDescription") {
      setRejectDescription(value);
    }
  };

  const toggleReportModal = () => {
    setIsReportModalOpen(!isReportModalOpen);
    setReportModalTitle(`Report order #${props.orderDetails?.orderNumber || orderID}`);
  };

  const sendReportHandler = () => {
    const { profile } = props;
    const date = new Date();
    const dateString = `${date.getDate()}/${
      date.getMonth() + 1
    }/${date.getFullYear()} - ${date.getHours()}:${date.getMinutes()}`;

    const emailHTML = `<div>
  <span style="font-size: 18px;">
  Hello, <br/>
  There is a new report for you from the D'Butler platform. Take a look and review the information below.
  </span><br/><br/>
  <div style="displa: flex; flex-direction: column;">
    <span style="font-weight: bold;">Report type:</span> <span>Order report</span><br/>
    <span style="font-weight: bold;">Time of report:</span> <span>${dateString}</span><br/>
    <span style="font-weight: bold;">User who sent the report:</span> <span>${profile.name} (email: ${profile.emailContact} phone: ${profile.phoneContact})</span><br/>
    <span style="font-weight: bold;">Reported order:</span> <span>Order number ${orderID}</span><br/>
  </div><br/><span style="font-weight: bold;">Platform:</span><span>Desktop</span><br/>
  <span style="font-weight: bold;">Report text:</span><br/><br/>
  <span style="font-size: 18px;">${reportModalText}</span>
<br /><br/><span style="font-size: 18px;">Yours truly, <br /> D'Bot.</span>
</div>`;

    props.reportProblem(reportModalTitle, emailHTML, toggleReportModal);
  };

  const closeRejectModal = () => {
    const resetCheckboxList = checkboxList.map(item => ({ ...item, checked: false }));
    setCheckboxList(resetCheckboxList);
    setRejectOrderModalOpen(false);
    setRejectDescription("");
  };

  const checkboxHandler = (index) => {
    const newCheckboxList = checkboxList.map((item, idx) => ({
      ...item,
      checked: idx === index ? !item.checked : false
    }));
    setCheckboxList(newCheckboxList);
  };

  const sendRejectOrder = async () => {
    let reason = "";
    checkboxList.forEach((value) => {
      if (value.checked) reason = value.name;
    });

    setRejectionLoading(true);

    try {
      // Use new backend cancel endpoint with proper request body
      await axios.put(`/orders/${props.orderDetails.id}/cancel`, {
        reason: reason,
        message: rejectDescription,
      });
      
      setRejectionLoading(false);
      closeRejectModal();
      callGetAPI();
    } catch (error) {
      console.error('Error cancelling order:', error);
      setRejectionLoading(false);
    }
  };

  const handleRejectProduct = () => {
    const { orderDetails } = props;
    const oldOrder = { ...orderDetails };

    // Update items array, setting isAvailable to false (inverted from old outOfStock logic)
    oldOrder.items = oldOrder.items.map((value) => {
      if (selectedItem.id === value.id) {
        return { ...value, isAvailable: false };
      }
      return value;
    });

    props.rejectProduct(oldOrder, handleRejectProductcloseModal);
  };

  const handleRejectProductOpenModal = (item) => {
    setIsRejectProductModalOpen(true);
    setSelectedItem(item);
  };

  const handleRejectProductcloseModal = () => {
    setIsRejectProductModalOpen(false);
    setSelectedItem(null);
  };

  const {
    loading,
    orderDetails,
    confirmLoading,
    reportLoading,
    rejectProductLoading,
  } = props;

  // Guard clause: prevent null reference errors
  if (!orderDetails && !loading) {
    return <div className="orderDetailsRoot"><Spinner /></div>;
  }

  let borderTopColor = "";
  let textColor = "";
  let orderItemListView = [];
  let statusDisplay = "";
  let statusId = 0;

  if (orderDetails !== null) {
    // Map backend status enum to UI display and colors
    const statusMap = {
      'PENDING': { display: 'Pending', id: 1 },
      'CONFIRMED': { display: 'In progress', id: 2 },
      'PREPARING': { display: 'In progress', id: 2 },
      'READY': { display: 'In progress', id: 2 },
      'OUT_FOR_DELIVERY': { display: 'In progress', id: 2 },
      'DELIVERED': { display: 'Completed', id: 3 },
      'CANCELLED': { display: 'Rejected', id: 4 },
    };
    
    const statusInfo = statusMap[orderDetails.status] || { display: 'Pending', id: 1 };
    statusDisplay = statusInfo.display;
    statusId = statusInfo.id;

    switch (statusDisplay) {
      case "Pending":
        borderTopColor = "borderTopPending";
        textColor = "textColorPending";
        break;
      case "In progress":
        borderTopColor = "borderTopInProgress";
        textColor = "textColorInProgress";
        break;
      case "Completed":
        borderTopColor = "borderTopCompleted";
        textColor = "textColorCompleted";
        break;
      case "Rejected":
        borderTopColor = "borderTopRejected";
        textColor = "textColorRejected";
        break;
      default:
        borderTopColor = "borderTopPending";
        textColor = "textColorPending";
        break;
    }

    if (orderDetails.items) {
      orderDetails.items.forEach((item, index) => {
        // Calculate discounted price if discount exists
        // Convert string values to numbers for calculations
        const unitPrice = Number(item.unitPrice) || 0;
        const discountAmount = Number(item.discountAmount) || 0;
        const quantity = Number(item.quantity) || 0;
        const totalPrice = Number(item.totalPrice) || 0;
        
        const discountedPrice = unitPrice - (quantity > 0 ? discountAmount / quantity : 0);
        const hasDiscount = discountAmount > 0;
        const discountPercent = hasDiscount && quantity > 0
          ? Math.round((discountAmount / (unitPrice * quantity)) * 100) 
          : 0;

        orderItemListView.push(
          <div className="orderDetailsListRow" key={index}>
            <div className="listRowImage">
              <img src={item.product?.images?.[0] || item.product?.imageUrl || '/img/placeholder.png'} alt="Item logo" />
            </div>
            <div
              className="listRowName"
              style={{
                width: statusId === 1 ? "200px" : "400px",
              }}
            >
              {item.productName}
            </div>
            <div className="listRowSmallText">Barcode: {item.product?.barcode || 'N/A'}</div>
            <div className="listRowUnitPrice">
              <span>
                QAR {discountedPrice.toFixed(2)}
              </span>
              <div className="listRowSmallText">
                {hasDiscount ? (
                  <>
                    <span style={{ textDecoration: "line-through" }}>
                      QAR {unitPrice.toFixed(2)}/
                    </span>
                    <span>{discountPercent}% off</span>
                  </>
                ) : null}
              </div>
            </div>
            <div className="listRowSmallText">
              {quantity || "OoS"}
            </div>
            <div
              className="listRowSmallTotalPrice"
              style={{
                width: statusId === 1 ? "120px" : "100px",
              }}
            >
              QAR {totalPrice.toFixed(2)}
            </div>
            {statusId === 1 ? (
              orderDetails.items.length === 1 ? (
                <div className="rejectButtonDisabled">Reject product</div>
              ) : !item.isAvailable ? (
                <div className="rejectedButton">Rejected</div>
              ) : (
                <div
                  className="rejectButton"
                  onClick={() => handleRejectProductOpenModal(item)}
                >
                  Reject product
                </div>
              )
            ) : null}
          </div>
        );
      });
    }
  }

  return (
    <div className="orderDetailsRoot">
      {isRejectProductModalOpen && selectedItem ? (
        <div className="inventoryModal">
          <div
            className="inventoryModalBackdrop"
            onClick={handleRejectProductcloseModal}
          ></div>
          <div className="orderModalReport animated bounceIn">
            <div className="AIMTitle">
              <span>Reject a product</span>
              <div onClick={handleRejectProductcloseModal}>
                <ClearIcon fontSize="default" color="inherit" />
              </div>
            </div>
            <div className="rejectProductModalContent">
              <span>{selectedItem?.productName}</span>

              <div className="rejectImage">
                <img src={selectedItem?.product?.images?.[0] || selectedItem?.product?.imageUrl || '/img/placeholder.png'} alt="rejected item" />
              </div>

              {rejectProductLoading ? (
                <div>
                  <Spinner />
                </div>
              ) : (
                <div
                  className="rejectModalButton"
                  onClick={handleRejectProduct}
                >
                  Reject
                </div>
              )}
            </div>
          </div>
        </div>
      ) : null}
      {isReportModalOpen ? (
        <div className="inventoryModal">
          <div
            className="inventoryModalBackdrop"
            onClick={toggleReportModal}
          ></div>
          <div className="orderModalReport animated bounceIn">
            <div className="AIMTitle">
              <span>Report a problem</span>
              <div onClick={toggleReportModal}>
                <ClearIcon fontSize="default" color="inherit" />
              </div>
            </div>
            <div className="orderModalReportContent">
              <div className="orderModalReportInputs">
                <span>Subject:</span>
                <input
                  type="text"
                  placeholder="Subject title"
                  name="reportModalTitle"
                  value={reportModalTitle}
                  onChange={handleReportInputs}
                  disabled
                />
              </div>
              <div className="orderModalReportInputs">
                <span>Description:</span>
                <textarea
                  cols="30"
                  rows="10"
                  placeholder="Subject description"
                  name="reportModalText"
                  value={reportModalText}
                  onChange={handleReportInputs}
                ></textarea>
              </div>
              <div className="orderModalReportButtons">
                {reportLoading ? (
                  <Spinner />
                ) : (
                  <>
                    <div
                      className="orderModalReportCancel"
                      onClick={toggleReportModal}
                    >
                      Cancel
                    </div>
                    <div
                      className="orderModalReportSubmit"
                      onClick={sendReportHandler}
                    >
                      Submit Report
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      ) : null}
      {rejectOrderModalOpen ? (
        <div className="inventoryModal">
          <div
            className="inventoryModalBackdrop"
            onClick={closeRejectModal}
          ></div>
          <div className="orderModalReport animated bounceIn">
            <div className="AIMTitle">
              <span>Reject an order</span>
              <div onClick={closeRejectModal}>
                <ClearIcon fontSize="default" color="inherit" />
              </div>
            </div>
            <div className="orderModalReportContent">
              <div className="orderModalReportInputs">
                <span>Reason for your rejection:</span>

                {checkboxList.map((value, index) => {
                  return (
                    <div
                      key={index}
                      onClick={() => checkboxHandler(index)}
                      style={{
                        display: "flex",
                        alignItem: "center",
                        cursor: "pointer",
                      }}
                    >
                      <input
                        type="checkbox"
                        checked={value.checked}
                        readOnly
                      />
                      <span style={{ marginLeft: 5 }}>{value.name}</span>
                    </div>
                  );
                })}
              </div>
              <div className="orderModalReportInputs">
                <span style={{ width: 200 }}>
                  Please tell us about the rejection in more detail:
                </span>
                <textarea
                  cols="30"
                  rows="10"
                  placeholder="Your explanation here"
                  name="rejectDescription"
                  value={rejectDescription}
                  onChange={handleReportInputs}
                ></textarea>
              </div>
              <div className="orderModalReportButtons">
                {rejectionLoading ? (
                  <Spinner />
                ) : (
                  <>
                    <div
                      className="orderModalReportCancel"
                      onClick={closeRejectModal}
                    >
                      Cancel
                    </div>
                    <div
                      className="orderModalReportSubmit"
                      onClick={sendRejectOrder}
                    >
                      Reject order
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      ) : null}
      {loading ? (
        <Spinner />
      ) : orderDetails ? (
        <div className={`orderDetailsBox ${borderTopColor}`}>
          <div className="orderDetailsTitle">
            Order #{orderDetails.orderNumber}
          </div>
          <div className="orderDetailsStatus">
            <span>Status: </span>
            <span className={`${textColor}`}>{statusDisplay}</span>
          </div>
          <div className="orderDetailsStatus">
            <span>Shop: </span>
            <span>#{orderDetails.clientId}</span>
          </div>
          <div className="orderDetailsItemListBox">{orderItemListView}</div>
          <div className="orderDetailsTotalPriceBox">
            <div className="orderDetailspriceBox">
              <div className="orderDetailsSmallPrice">
                <span style={{ width: "150px", textAlign: "right" }}>
                  Subtotal ({orderDetails.items?.length || 0} items):
                </span>
                <span>QAR {Number(orderDetails.itemsSubtotal).toFixed(2)}</span>
              </div>
              <div className="orderDetailsBigPrice">
                <span style={{ width: "150px", textAlign: "right" }}>
                  Order total:
                </span>
                <span style={{ fontSize: "24px" }}>
                  QAR {Number(orderDetails.totalAmount).toFixed(2)}
                </span>
              </div>
            </div>
          </div>

          <div className="orderDetailsFooter">
            <div className="orderDetailsPDFbuttons">
              <>
                <a
                  href={`${serverAddress}purchase-order/${orderDetails.id}`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <div className="orderModalViewPDF centerText">
                    View and print in PO
                  </div>
                </a>
                {statusId === 3 ? (
                  <>
                    <a
                      href={`${serverAddress}grn/${orderDetails.id}`}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <div className="orderModalViewPDF centerText">
                        View and print GRN
                      </div>
                    </a>
                    <a
                      href={`${serverAddress}invoice/${orderDetails.id}`}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <div className="orderModalViewPDF centerText">
                        View and print Invoice
                      </div>
                    </a>
                    <a
                      href={`${serverAddress}delivery-note/${orderDetails.id}`}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <div className="orderModalViewPDF centerText">
                        View and print Delivery Note
                      </div>
                    </a>
                  </>
                ) : null}
              </>
            </div>
            <div className="orderDetailsButtons">
              {statusId === 1 ? (
                <>
                  {confirmLoading ? (
                    <div className="orderModalConfirmLoading">
                      <Spinner />
                    </div>
                  ) : (
                    <>
                      <div
                        className="orderModalReject"
                        onClick={() =>
                          handleClickOrder(orderDetails.id, 'cancel')
                        }
                      >
                        Reject order
                      </div>
                      <div
                        className="orderModalConfirm"
                        onClick={() =>
                          handleClickOrder(orderDetails.id, 'confirm')
                        }
                      >
                        Confirm order
                      </div>
                    </>
                  )}
                </>
              ) : null}
            </div>
          </div>
          <div
            className="orderDetailsReportOrder"
            onClick={toggleReportModal}
          >
            Report this order
          </div>
        </div>
      ) : null}
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    loading: state.orders.oneOrderLoading,
    orderDetails: state.orders.orderDetails,
    confirmLoading: state.orders.confirmLoading,
    reportLoading: state.report.loading,
    empID: state.profile.profileDetails.employeeId,
    profile: state.profile.profileDetails,
    rejectProductLoading: state.orders.rejectProductLoading,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getOneOrders: (id) => dispatch(actions.getOneOrders(id)),
    confirmOrder: (orderID, statusID, cb) =>
      dispatch(actions.confirmOrder(orderID, statusID, cb)),
    reportProblem: (title, desc, func) =>
      dispatch(actions.reportProblem(title, desc, func)),
    rejectProduct: (order, cb) => dispatch(actions.rejectProduct(order, cb)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(OrderDetails);
